import { useEffect } from 'react';
import { type VerificationServiceWidgetConfiguration } from '@/features/user-verification/api/types';
import { useCyberityLaunch } from '../model/useCyberityLaunch';
import type { UserProfileInfoMap } from '@/entities/user';

const CyberityWidget = ({
  widgetConfiguration,
  getNewAccessToken,
  userProfile,
}: {
  widgetConfiguration: VerificationServiceWidgetConfiguration;
  getNewAccessToken: () => Promise<string>;
  userProfile: UserProfileInfoMap;
}) => {
  const containerId = 'verification-websdk-container';

  const { launchWebSdk } = useCyberityLaunch({
    lang: widgetConfiguration.languageCode,
    containerId,
    getNewAccessToken,
  });

  useEffect(() => {
    launchWebSdk(
      widgetConfiguration.accessToken,
      userProfile.email,
      userProfile.phone
    );
  }, [launchWebSdk, widgetConfiguration]);

  return <div id={containerId} />;
};

export { CyberityWidget };
